namespace AgerLMS.LMS {
    export class DetailMetaColumns {
        static columnsKey = 'LMS.DetailMeta';
    }
}
